type IDarkenColorInput = {
  hexColor: string;
  percentage: number;
  opacityPercentage?: number;
}

export const darkenColor = ({ hexColor, percentage, opacityPercentage }: IDarkenColorInput) => {
  if(!hexColor) {
    return;
  }
  const parsedHexColor = hexColor.replace('#', '');

  const r = parseInt(parsedHexColor.substring(0, 2), 16);
  const g = parseInt(parsedHexColor.substring(2, 4), 16);
  const b = parseInt(parsedHexColor.substring(4, 6), 16);

  const darken = (channel: number) => Math.max(0, Math.min(255, channel - channel * percentage));

  const darkenedR = Math.round(darken(r));
  const darkenedG = Math.round(darken(g));
  const darkenedB = Math.round(darken(b));

  if(opacityPercentage) {
    return `rgba(${darkenedR}, ${darkenedG}, ${darkenedB}, ${opacityPercentage})`;
  }
  return `rgb(${darkenedR}, ${darkenedG}, ${darkenedB})`;
};
